import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from './useIsAdmin';

/* Client-side gate for Triton-admin-only routes. This is UX only — the Worker
   must independently authorize cross-tenant access server-side (Phase 3+). */
export function RequireAdmin() {
  const isAdmin = useIsAdmin();
  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
}
